import { render, staticRenderFns } from "./InsertDesign.vue?vue&type=template&id=647bb364&scoped=true&"
import script from "./InsertDesign.vue?vue&type=script&lang=js&"
export * from "./InsertDesign.vue?vue&type=script&lang=js&"
import style0 from "./InsertDesign.vue?vue&type=style&index=0&id=647bb364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647bb364",
  null
  
)

export default component.exports